import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

import moment from 'moment'
import generals from '@/common-vue/mixins/generals'
import orders_mixin from '@/mixins/orders'
export default {
	namespaced: true,
	state: {
		model_name: 'order',
		from_dates: true,

		models: [],
		model: {},
		selected: [],
		filtered: [],
		is_filtered: false,

		from_date: moment().format('YYYY-MM-DD'),
		until_date: '',

		delete: null,
		delete_image: null,
		
		prop_model_to_delete: null,

		display: 'cards',

		loading: false,

		// Create
		products: [],
		total: 0,

		// Previus
		index: 0,

		// Sonido Timbre
		intervalos_timbre: [],

		deleted_models: [],
	},
	mutations: {
		addIntervaloTimbre(state, intervalo_to_add) {
			let index = state.intervalos_timbre.findIndex(intervalo => {
				return intervalo.order_id == intervalo_to_add.order_id 
			})
			if (index != -1) {
				state.intervalos_timbre.splice(index, 1)
				console.log('se quito intervalo:')
				// console.log(intervalo)
			} else {
				console.log('se agrego intervalo:')
				// console.log(intervalo)
				state.intervalos_timbre.push(intervalo_to_add)
			}
		},
		setDeletedModels(state, value) {
			state.deleted_models = value 
		},
		setLoading(state, value) {
			state.loading = value
		},
		setModel(state, value = null) {
			if (value && value.model) {
				state.model = value.model
				if (value.properties && value.properties.length) {
					value.properties.forEach(prop => {
						state.model[prop.key] = prop.value 
					})
				}
			} else {
				let obj = {
					id: null
				}
				require(`@/models/${state.model_name}`).default.properties.forEach(prop => {
					obj[prop.key] = prop.value 
				})
				if (value && value.properties && value.properties.length) {
					value.properties.forEach(prop => {
						obj[prop.key] = prop.value 
					})
				}
				state.model = obj
			}
		},
		setModels(state, value) {
			if (value) {
				state.models = value
			} else {
				state.models = []
			}
		},
		setSelected(state, value) {
			state.selected = value
		},
		setFiltered(state, value) {
			state.filtered = value
		},
		setIsFiltered(state, value) {
			state.is_filtered = value
		},
		add(state, value) {
			let index = state.models.findIndex(item => {
				return item.id == value.id
			})
			if (index == -1) {
				state.models.unshift(value)
			} else {
				state.models.splice(index, 1, value)
			}

			index = state.filtered.findIndex(item => {
				return item.id == value.id
			})
			if (index != -1) {
				state.filtered.splice(index, 1, value)
			} 
		},
		setDelete(state, value) {
			state.delete = value
		},
		delete(state) {
			// Models
			let index = state.models.findIndex(model => {
				return model.id == state.delete.id
			})
			state.models.splice(index, 1)

			// Filtereds
			index = state.filtered.findIndex(model => {
				return model.id == state.delete.id
			})
			if (index != -1) {
				state.models.splice(index, 1)
			}
		},
		setDeleteImage(state, value) {
			state.delete_image = value
		},
		deleteImage(state, value) {
			let index = state.models.images.findIndex(model => {
				return model.id == state.delete_image.id
			})
			if (index != -1) {
				state.model.images.splice(index, 1)
			}
		},
		setPropModelToDelete(state, value) {
			state.prop_model_to_delete = value
		},
		deletePropModel(state) {
			let index = state.model[state.prop_model_to_delete.key].findIndex(model => {
				return model.id == state.prop_model_to_delete.id
			})
			state.model[state.prop_model_to_delete.key].splice(index, 1)
		},
		setDisplay(state, value) {
			state.display = value 
		},
		setFromDate(state, value) {
			state.from_date = value
		},
		setUntilDate(state, value) {
			state.until_date = value
		},

		//  Create products
		setProducts(state, value = []) {
			state.products = value
		},
		addProduct(state, value) {
			state.products.unshift(value)
		},
		updateProduct(state, value) {
			let index = state.products.findIndex(item => {
				return item.id == value.id
			})
			state.products.splice(index, 1, value)
		},
		removeProduct(state, value) {
			let index = state.products.findIndex(item => {
				return item.id == value.id
			})
			state.products.splice(index, 1)
		},
		setTotal(state, value = null) {
			if (value) {
				state.total = value
			} else {
				state.total = orders_mixin.methods.getTotalProducts(state.products, state.model.discount, false, false)
			}
		},

		// Index Previus
		incrementIndex(state) {
			state.index++
		},
		decrementIndex(state) {
			state.index--
		},
		setIndex(state, value = 0) {
			state.index = value
		},
	},
	actions: {
		getModels({ commit, state }) {
			commit('setLoading', true)
			let url = '/api/'+generals.methods.routeString(state.model_name)
			if (state.from_dates) {
				url += '/'+state.from_date
			} 
			if (state.until_date != '') {
				url += '/'+state.until_date
			}
			return axios.get(url)
			.then(res => {
				commit('setLoading', false)
				commit('setModels', res.data.models)
			})
			.catch(err => {
				commit('setLoading', false)
				console.log(err)
			})
		},
		getDeletedModels({ commit, state }) {
			let url = '/api/'+generals.methods.routeString(state.model_name)+'-deleted-models'
			return axios.get(url)
			.then(res => {
				commit('setDeletedModels', res.data.deleted_models)
			})
			.catch(err => {
				console.log(err)
			})
		},
		delete({ commit, state }) {
			return axios.delete(`/api/${generals.methods.routeString(state.model_name)}/${state.delete.id}`)
			.then(() => {
				commit('delete')
			})
			.catch((err) => {
				console.log(err)
			})
		},
		deleteImage({ commit, state }) {
			return axios.delete(`/api/${generals.methods.routeString(state.model_name)}/image/${state.delete_image.id}`)
			.then((res) => {
				commit('add', res.data.model)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		deletePropModel({ commit, state }) {
			return axios.delete(`/api/${generals.methods.routeString(state.prop_model_to_delete.has_many.model_name)}/${state.prop_model_to_delete.id}`)
			.then(res => {
				commit('deletePropModel')
			})
			.catch(err => {
				console.log(err)
			})
		}
	},
}
